import { Component, OnInit } from '@angular/core';
import { AfterViewInit, ElementRef, } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { flatMap, toArray, map } from 'rxjs/operators';

@Component({
  selector: 'app-tops',
  
  

  //borrar todo lo verde y cambiar el templateUrl y vaciar al contructor 
  
  templateUrl: './tops.component.html',
  styleUrls: ['./tops.component.scss']
})
export class TopsComponent implements OnInit {
 // itemsRef: AngularFireList<unknown>;
 // items: any;

  scoreRef: AngularFireList<any>;
  scores: Observable<any[]>;

  constructor(db: AngularFireDatabase, afs: AngularFirestore) { 

    this.scores = db.object('scores').valueChanges().pipe(flatMap(scores => 
      Promise.all([...Object.entries(scores)].map(async user => {
        const doc = await afs.doc(`UsuariosFeos/${user[0]}`).get().toPromise();
        return {
          nombre: doc.get("nombre"),
          score: Object.values(user[1]).sort((a: any, b: any) => b.score/b.duration - a.score/a.duration)[0]
        }
      }))
    ), map(scores => scores.sort((a: any, b: any) => b.score.score - a.score.score).filter((_x, i) => i < 10).map((x: any) => `${x.nombre} tiene un score de ${x.score.score} y lo hizo en ${x.score.duration} segundos.`)));
  }


  ngOnInit(): void {
  }

}
